import type {
	createRelationInput,
	decideRelationInput,
	getAggregatedSellerInput,
	getRelationInput,
	getRelationTransactionsInput,
	getRelationsInput,
	updateRelationInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useRelation: getRelationInput;
	useRelationTransactions: getRelationTransactionsInput;
	useGetRelations: getRelationsInput;
	useGetAggregatedSellers: getAggregatedSellerInput;
	useCreateRelation: createRelationInput;
	useDecideRelation: decideRelationInput;
	useUpdateRelation: updateRelationInput;
}

const RELATIONS_SERIVCE_KEYS = createReactQueryKeys<Keys>("relations", [
	"useRelation",
	"useRelationTransactions",
	"useGetRelations",
	"useGetAggregatedSellers",
	"useCreateRelation",
	"useDecideRelation",
	"useUpdateRelation",
]);

export { RELATIONS_SERIVCE_KEYS };
